module.exports = __webpack_public_path__ + "img/F1.4a4493f2.png";